import React from "react";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Button from "@material-ui/core/Button";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Theme } from "@material-ui/core/styles";

import useStyles from "./styles";

interface Props {
  children: React.ReactNode;
  header?: string | React.ReactNode;
  subHeader?: string | React.ReactNode;
  className?: string;
  contentClassName?: string;
  dataTestId?: string;
  withMaxHeight?: boolean;
  initialItemsCount?: number;
}

const DashboardCard = ({
  children,
  header,
  subHeader,
  className,
  contentClassName,
  dataTestId,
  withMaxHeight = true,
  initialItemsCount = 0
}: Props) => {
  const classes = useStyles();

  const [isExpanded, setIsExpanded] = React.useState(false);

  const matchesUpMd = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("md")
  );

  const childrenItems = React.Children.toArray(children);
  const shouldLimitItems = [
    initialItemsCount,
    childrenItems.length > initialItemsCount
  ].every(Boolean);
  const displayedChildren =
    shouldLimitItems && !isExpanded
      ? childrenItems.slice(0, initialItemsCount)
      : childrenItems;
  const viewMoreButtonContent = isExpanded ? "View Less" : "View More";

  const handleViewMoreButtonClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className={clsx(classes.root, className, {
        [classes.maxHeight]: withMaxHeight && matchesUpMd
      })}
      data-test-id={dataTestId}
    >
      {Boolean(header) && <div className={classes.header}>{header}</div>}
      {Boolean(subHeader) && (
        <div className={classes.subHeader}>{subHeader}</div>
      )}
      <div className={clsx(classes.content, contentClassName)}>
        {displayedChildren}
        {shouldLimitItems && (
          <Button
            className={classes.viewMoreButton}
            type="button"
            onClick={handleViewMoreButtonClick}
          >
            {viewMoreButtonContent}
            <ExpandMoreIcon
              className={clsx(classes.viewMoreIcon, {
                [classes.viewLessIcon]: isExpanded
              })}
            />
          </Button>
        )}
      </div>
    </div>
  );
};
export default React.memo(DashboardCard);
